import Vue from "vue";
import moment from "moment";

// URL Default de acesso ao sistema de recurso da aplicação

export const baseApiUrl = process.env.VUE_APP_API_URL;

export const sexo = [
  { name: "Masculino", code: "M" },
  { name: "Feminino", code: "F" },
];

export const simNao = [
  { name: "Não", code: "N" },
  { name: "Sim", code: "S" },
];

export const money = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  suffix: "",
  precision: 2,
  masked: false,
};

export const paginasChefia = [
  "gerenciaPendente",
  "gerenciaConcluido",
  "gerenciaRejeitados",
  "CHEFIAGERENCIA_VALIDACOES",
  "gerenciaRelatorios",
  "cadastroUsuario",
  "cadastroPerfilUsuario",
  // 'administrativoCiclo',
  "listaCiclo",
  "gerenciaNovoCiclo",
  "gerenciaNovoQuestionario",
  "novoQuestionarioPergunta",
  "manterOpcoesPergunta",
  "visualizarCiclo",
];

export const perfisAdm = [
  {
    perfil: "ADMINISTRADOR CENTRAL - RECADASTRO",
    permissoes: [
      "gerenciaRelatorios",
      "cadastroUsuario",
      "cadastroPerfilUsuario",
      "administrativoCiclo",
      "listaCiclo",
      "gerenciaNovoCiclo",
      "gerenciaNovoQuestionario",
      "novoQuestionarioPergunta",
      "manterOpcoesPergunta",
      "visualizarCiclo",
      "regularizacaoServidor",
    ],
  },
  {
    perfil: "ADMINISTRADOR SETORIAL - RECADASTRO",
    permissoes: ["gerenciaRelatorios"],
  },
];

export const perfis = [
  {
    perfil: "RECADRL_CHEFIA",
    permissoes: [
      "gerenciaPendente",
      "gerenciaConcluido",
      "gerenciaRejeitados",
      "CHEFIAGERENCIA_VALIDACOES",
      "recadastramento",
      "dadosPessoais",
      "documentos",
      "endereco",
      "formacaoAcademica",
      "dependentes",
      "capacitacao",
      "experiencia-profissional",
      "questionario",
      "vinculos",
      "termoaceiterecadastramento",
      "faq",
      "faleconosco",
    ],
  },
  {
    perfil: "RECAD_GERAL",
    permissoes: [
      "recadastramento",
      "dadosPessoais",
      "documentos",
      "endereco",
      "formacaoAcademica",
      "dependentes",
      "capacitacao",
      "experiencia-profissional",
      "capacitacao",
      "questionario",
      "vinculos",
      "termoaceiterecadastramento",
      "faq",
      "faleconosco",
    ],
  },
];

// Tratamento de erro geral das telas
Vue.config.errorHandler = function(err, vm, info) {
  // trata a mensagem para ser exibida ao usuário)
  exibirErroTratado(err, vm, "error", info);
};

export function exibirErroTratado(error, vm, severity, info) {
  // Cria as variavel de mensagem ao usuário
  let msgUsuario = "";
  // Verifica mensagem retornada
  if (error && error.response && error.response.data) {
    if (
      Array.isArray(error.response.data) &&
      error.response.data[0].msgUsuario
    ) {
      msgUsuario = error.response.data[0].msgUsuario;
    } else {
      msgUsuario = error.response.data;
    }
  } else if (typeof error === "string") {
    msgUsuario = error;
  } else {
    msgUsuario = info;
  }

  if (typeof msgUsuario != "object") {
    Vue.prototype.$toast.add({ severity, summary: msgUsuario, life: 15000 });
  }
}

Vue.config.warnHandler = function(msg, vm) {
  exibirErroTratado(
    msg,
    vm.parent,
    "warn",
    "Um alerta na operação do sistema foi gerado"
  );
};

export function languagePtBr() {
  return {
    firstDayOfWeek: 0,
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    today: "Hoje",
    clear: "Limpar",
    dateFormat: "dd/mm/yy",
    weekHeader: "Sm",
  };
}

export function printToast({ severity, summary, detail = "" }) {
  let maiorMessage = `${summary} ${detail}`;
  let messageLength = maiorMessage.split(" ").length;
  let life = (messageLength * 60000) / 150;
  Vue.prototype.$toast.add({ severity, summary, detail, life });
}

export function isDate(data) {
  return data instanceof Date && !isNaN(data.valueOf());
}

export function strToDate(objeto, campos) {
  // Percorre a array de campos
  for (var i = 0; i < campos.length; i++) {
    // Verifcia se é a propriedade display format
    if (campos[i].displayFormat) {
      // carrega o objeto campo
      var campo = campos[i];
      // Converte a string para o formato data
      objeto[campo] = moment(objeto[campo], campo.displayFormat).toDate();
    }
  }
}

export function dateToStr(objeto, campos) {
  // Percorre a array de campos
  for (var i = 0; i < campos.length; i++) {
    // Verifcia se é a propriedade display format
    if (campos[i].displayFormat) {
      // carrega o objeto campo
      var campo = campos[i];
      // Converte a string para o formato data
      objeto[campo.nome] = moment(objeto[campo.nome]).format(
        campo.displayFormat
      );
    }
  }
}

export default {
  baseApiUrl,
  sexo,
  simNao,
  money,
  perfis,
  perfisAdm,
  paginasChefia,
  languagePtBr,
  isDate,
  strToDate,
  dateToStr,
  exibirErroTratado,
};
